import { cn } from '@/src/utils';
import React, {
  forwardRef,
  HTMLAttributes,
  PropsWithChildren,
  ReactNode,
} from 'react';

interface SectionCardNoneTitleProps extends HTMLAttributes<HTMLDivElement> {
  rightAccessary?: ReactNode;
  contentProps?: HTMLAttributes<HTMLDivElement>;
}

const SectionCardNoneTitle = forwardRef<
  HTMLDivElement,
  PropsWithChildren<SectionCardNoneTitleProps>
>(({ children, contentProps, ...props }, ref) => {
  return (
    <article
      ref={ref}
      className={cn(
        'rounded-2xl bg-white p-4 shadow-sectionCard',
        props.className,
      )}
      {...props}
    >
      {children && <section {...contentProps}>{children}</section>}
    </article>
  );
});

export default SectionCardNoneTitle;
